module.exports = "<app-photo-edit photo-list=$ctrl.route.photos main-lang=$ctrl.route.main_lang ng-form name=routeEditPhotoForm on-crop-change=\"$ctrl.cropChanged(id, crop)\"> </app-photo-edit> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/photos/partial.html
// module id = 475
// module chunks = 0